export default __webpack_public_path__ + "static/media/hero-programs.9c624736.png";